import { render, staticRenderFns } from "./HighlightContentsSection.vue?vue&type=template&id=58759e0f&scoped=true"
import script from "./HighlightContentsSection.vue?vue&type=script&lang=ts"
export * from "./HighlightContentsSection.vue?vue&type=script&lang=ts"
import style0 from "./HighlightContentsSection.vue?vue&type=style&index=0&id=58759e0f&prod&lang=scss&scoped=true"
import style1 from "./HighlightContentsSection.vue?vue&type=style&index=1&id=58759e0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58759e0f",
  null
  
)

export default component.exports